import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import styles from './NonEval.module.css';
import { DBTextArea, DBDropDown, CancelButton } from '_components';


class PatientCareCenterNoteSubjectiveNonEvalEntry extends React.Component {

    handleRemove() {
        this.props.removeChildRow(this.props.noteId, 'PTSUBJECTIVE', 'SU', this.props.subj.SUNO);
    }

    render() {
        return (
            <div>
                {/* <div className={styles.row}>
                    <span className={styles.col1} />
                    <DBDropDown
                        noteId={this.props.noteId}
                        entity='PTSUBJECTIVE'
                        entityKeyColumn='SUNO'
                        entityKeyValue={this.props.subj.SUNO}
                        field='SUMSNO'
                        className={styles.dropdown}
                        masterEntity='PTMASTERSUBJECTIVE'
                        masterEntityKeyColumn='MSNO'
                        masterEntitySort='MSORDER'
                        masterEntityDisplay='MSNAME'
                    />
                    <span className={styles.remove_button}>
                        <CancelButton size='extra-small' title='Remove Subjective...' onClick={() => this.handleRemove()} />
                    </span>
                </div> */}

                <div className={styles.row}>
                    <span className={styles.col1} />
                    <span className={styles.textarea_wrapper}>
                        <DBTextArea
                            noteId={this.props.noteId}
                            entity='PTSUBJECTIVE'
                            entityKeyColumn='SUNO'
                            entityKeyValue={this.props.subj.SUNO}
                            field='SUDETAILS'
                            className={styles.textarea}
                        />
                    </span>
                </div>

            </div >
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let subj = state.entities.notes.PTSUBJECTIVE[ownprops.id];

    return {
        noteId,
        subj,
    };
}

const connectedPatientCareCenterNoteSubjectiveNonEvalEntry = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteSubjectiveNonEvalEntry);
export { connectedPatientCareCenterNoteSubjectiveNonEvalEntry as PatientCareCenterNoteSubjectiveNonEvalEntry };

